import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './css/home.css';
import './css/header.css';
import './css/aboutus.css';
import './css/service.css';
import './css/search.css';
import './css/contact.css';
import './css/RecordesPageStyle/recordes.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import Root from './routes/Root';

function App() {
  return (
    <>
      <Root />
    </>
  );
}

export default App;
